export const CLICK_CHANGE_PHONE_NUMBER = 'clickChangePhoneNumber';
export const SUCCESS_CHANGE_MOBILE_PHONE_NUMBER =
  'successChangeMobilePhoneNumber';
export const FAILURE_CHANGE_MOBILE_PHONE_NUMBER =
  'failureChangeMobilePhoneNumber';
export const CLICK_RESEND_TOKEN = 'clickResendToken';
export const SUCCESS_RESEND_TOKEN = 'successResendToken';
export const FAILURE_RESEND_TOKEN = 'failureResendToken';
export const TOKEN_INPUT = {
  SUCCESS: 'successInputToken',
  FAILURE: 'failureInputToken',
  FAILURE_LABEL: 'Falha ao enviar o token'
};

// private tracker
export const CLICK_GO_TO_PUBLIC_TRACKER = 'clickGoToPublicTracker';
export const CATEGORY_NAME = {
  EDIT_ADDRESS_AUTHENTICATION: 'editAddressAuthentication',
  EDIT_ADDRESS: 'editAddress'
};

export const AUTHENTICATION_INPUT = {
  SUCCESS: {
    ACTION: 'successAuthenticationInput',
    LABEL: {
      CPF: 'Sucesso ao autenticar usuário CPF',
      CNPJ: 'Sucesso ao autenticar usuário CNPJ'
    }
  },
  FAILURE: {
    ACTION: 'failureAuthenticationInput',
    LABEL: {
      CPF: 'Falha ao autenticar usuário CPF',
      CNPJ: 'Falha ao autenticar usuário CNPJ',
      EXCEEDED_ATTEMPTS: 'tentativa de autenticação excedida'
    }
  }
};

export const AFTER_CONFIRMING_ADDRESS_CHANGE = {
  RETRY_CHANGE_ADDRESS: {
    ACTION: 'retryChangeAddress',
    LABEL: 'Editar endereço novamente pós confirmação da alteração de endereço'
  },
  REDIRECT_TO_PACKAGE_STATUS: {
    ACTION: 'redirectToPackageStatus',
    LABEL: 'Acompanhar pedido pós confirmação da alteração de endereço'
  }
};

export const CHANGE_ADDRESS_CONFIRMATION = {
  true: {
    ACTION: 'successChangeAddressConfirmation',
    LABEL: 'Sucesso ao confirmar alteração de endereço'
  },
  false: {
    ACTION: 'failureChangeAddressConfirmation',
    LABEL: 'Falha ao confirmar alteração de endereço'
  },
  CLIENT_OR_SERVER_ERROR: {
    NAME: 'CLIENT_OR_SERVER_ERROR',
    ACTION: 'clientOrServerErrorChangeAddressConfirmation',
    LABEL: 'Erro de sistema'
  },
  RETRY: {
    NAME: 'RETRY',
    ACTION: 'retryChangeAddressConfirmation',
    LABEL: 'Tentar novamente a alteração de endereço'
  },
  RECEIVER_NOT_AUTHENTICATED: {
    NAME: 'RECEIVER_NOT_AUTHENTICATED',
    ACTION: 'missAuthenticationWhenChangeAddressConfirmation',
    LABEL: 'Usuário não autenticado ao confirmar alteração de endereço'
  },
  GO_BACK_TO_CHANGE_ADDRESS: {
    NAME: 'GO_BACK_TO_CHANGE_ADDRESS',
    ACTION: 'goBackToChangeAddressTypeaheadScreen',
    LABEL: 'Voltar para a tela com input de alteração do endereço'
  }
};

export const EDIT_ADDRESS_TYPEAHEAD = {
  FULL_ADDRESS: {
    SUCCESS: {
      ACTION: 'successEditFullAddress',
      LABEL: 'Click do botão continuar edição de endereço'
    },
    FAILURE: {
      ACTION: 'failureEditFullAddress',
      LABEL: 'Falha no click do botão continuar edição de endereço'
    }
  },
  COMPLEMENT: {
    ACTION: 'successEditComplement',
    LABEL: 'Click do botão continuar edição de endereço'
  }
};
